import { render, staticRenderFns } from "./navigate-top-left.vue?vue&type=template&id=5f36de33&scoped=true&"
import script from "./navigate-top-left.vue?vue&type=script&lang=js&"
export * from "./navigate-top-left.vue?vue&type=script&lang=js&"
import style0 from "./navigate-top-left.vue?vue&type=style&index=0&id=5f36de33&scoped=true&lang=less&rel=stylesheet%2Fless&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f36de33",
  null
  
)

export default component.exports